import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './realestate_v2/Header';
import Footer from './realestate_v2/Footer';
import Home from './realestate_v2/Home';
import Inventory from './realestate_v2/Inventory';
import Estate from './realestate_v2/Estate';
import Viewing from './realestate_v2/Viewing';

export default function RealEstateTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F4EFE5]" data-testid="ml-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`ml-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'inventory' && <Inventory setPage={setPage} />}
          {page === 'estate' && <Estate setPage={setPage} />}
          {page === 'viewing' && <Viewing setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
